import React, { useEffect, useState } from "react";
import { Typography, Spin } from 'antd';
//import SidebarLayoutConsumer from "./SidebarLayoutConsumer";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import Reports from "../Consumer/Reports";
import ReportsForAdmin from "../Administrator/ReportsForAdmin";

const { Title } = Typography;

const CapitalProviderReports = () => {

    const [loading, setLoading] = useState(false);
    const ConsumerUserId = localStorage.getItem("ConsumerUserId");

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <div>
                    <ReportsForAdmin consumerId={1} />
                </div>

            </SidebarLayoutConsumer >
        </Spin >
    );
};

export default CapitalProviderReports;